<template>
    <div id="footer" class="html-footer clearfix">
        <div class="footer_con">
            <div class="logo flex">
                <img :src="webInfo.logo" alt="logo">
                <div class="desc">
                    <h2>{{ webInfo.webName }}</h2>
                    <p>{{ webInfo.englishName }}</p>
                </div>
            </div>
            <div class="contact">
                <p>客服QQ:{{ webInfo.kfQq }}</p>
                <p>投诉举报:{{ webInfo.swhz }}</p>
                <p>公开热线：{{ webInfo.linkPhone }}</p>
            </div>
            <div class="qr_code">
                <img :src="webInfo.wxQrCode" alt="二维码">
            </div>
        </div>
        <div class="footer_area">
            <p class="copyright"> Copyright©1998-2022 KsOnline,All Rights Reserved</p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
    computed: mapState(['webInfo']),
    name: 'Footer',
    data() {
        return {

        }
    },
    mounted() {
        // 获取网站信息
        this.GetWebInfo();
    },
    methods: {
        ...mapActions(['GetWebInfo'])
    }
}
</script>

<style lang="scss" scoped>
#footer {
    width: 100%;
    height: 280px;
    background-color: #242424;
    text-align: center;
    box-sizing: border-box;

    .footer_con {
        padding-bottom: 28px;
        padding-top: 46px;
        margin: 0 auto;
        width: 1167px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #3F4159;
        box-sizing: border-box;

        .logo {
            align-items: flex-start;
            text-align: left;
            margin-left: 119px;

            img {
                width: 50px;
                height: 50px;
                margin-right: 10px;
            }

            h2 {
                font-size: 20px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 28px;
            }

            p {
                font-size: 14px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 28px;
            }
        }

        .contact {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
            text-align: left;
        }

        .qr_code {
            margin-right: 173px;

            img {
                width: 115px;
                height: 115px;
            }
        }
    }

    .footer_area {
        width: 100%;
        margin-top: 26px;
        text-align: center;

        p {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
        }
    }
}
</style>
